<template>
    <div class="d-flex">
        <div v-for="(icon, index) in calcScore" :key="index" class="mx-1">
            <div v-if="icon === 'heart-half'">
                <b-icon-heart-half :variant="variant" :font-scale="scale" />
            </div>
            <div v-else-if="icon === 'heart-fill'">
                <b-icon-heart-fill :variant="variant" :font-scale="scale" />
            </div>
            <div v-else>
                <b-icon-heart :variant="variant" :font-scale="scale" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ScoreHearts",
        props: {
            score: Number,
            variant: String,
            scale: Number
        },

        computed: {
            calcScore() {
                const hearts = [];
                const SCORE_POSITIONS = 4;
                const N_SCORE = Math.round(this.score/(100 / SCORE_POSITIONS) * 2) / 2;
                for (let i = 1; i <= SCORE_POSITIONS; i++) {
                    if (N_SCORE + 0.5 === i || N_SCORE + 0.25 === i) {
                        hearts.push("heart-half");
                    } else if (N_SCORE >= i) {
                        hearts.push("heart-fill");
                    } else {
                        hearts.push("heart");
                    }
                }
                return hearts;
            },
        },
    };
</script>
